import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UrlContant } from '../constants/router.contant';
import {
  CrematoriumForgotEmailComponent,
  CrematoriumLoginComponent,
  CrematoriumSignUpComponent,
  FloristForgotEmailComponent,
  FloristLoginComponent,
  FloristSignUpComponent,
  PanditForgotEmailComponent,
  PanditLoginComponent,
  PanditSetPasswordComponent,
  PanditSignUpComponent,
  TempleForgotEmailComponent,
  TempleLoginComponent,
  TempleSignUpComponent,
  UserForgotEmailComponent,
  UserLoginComponent,
  UserSetPasswordComponent,
  UserSignUpComponent,
} from './components';
import { AuthenticationComponent } from './components/authentication.component';

const routes: Routes = [
  {
    path: '',
    component: AuthenticationComponent,
    children: [
      {
        path: '',
        redirectTo: UrlContant.PANDIT_LOGIN,
      },
      {
        path: UrlContant.PANDIT_LOGIN_URL,
        component: PanditLoginComponent,
      },
      {
        path: UrlContant.PANDIT_SIGNUP_URL,
        component: PanditSignUpComponent,
      },
      {
        path: UrlContant.PANDIT_FORGOT_EMAIL_URL,
        component: PanditForgotEmailComponent,
      },
      {
        path: UrlContant.PANDIT_SET_PASSWORD_URL,
        component: PanditSetPasswordComponent,
      },
      {
        path: UrlContant.USER_LOGIN_URL,
        component: UserLoginComponent,
      },
      {
        path: UrlContant.USER_SIGNUP_URL,
        component: UserSignUpComponent,
      },
      {
        path: UrlContant.USER_FORGOT_EMAIL_URL,
        component: UserForgotEmailComponent,
      },
      {
        path: UrlContant.USER_SET_PASSWORD_URL,
        component: UserSetPasswordComponent,
      },
      {
        path: UrlContant.FLORIST_LOGIN_URL,
        component: FloristLoginComponent,
      },
      {
        path: UrlContant.FLORIST_SIGNUP_URL,
        component: FloristSignUpComponent,
      },
      {
        path: UrlContant.FLORIST_FORGOT_EMAIL_URL,
        component: FloristForgotEmailComponent,
      },
      {
        path: UrlContant.CREMATORIUM_LOGIN_URL,
        component: CrematoriumLoginComponent,
      },
      {
        path: UrlContant.CREMATORIUM_SIGNUP_URL,
        component: CrematoriumSignUpComponent,
      },
      {
        path: UrlContant.CREMATORIUM_FORGOT_EMAIL_URL,
        component: CrematoriumForgotEmailComponent,
      },
      {
        path: UrlContant.TEMPLE_LOGIN_URL,
        component: TempleLoginComponent,
      },
      {
        path: UrlContant.TEMPLE_SIGNUP_URL,
        component: TempleSignUpComponent,
      },
      {
        path: UrlContant.TEMPLE_FORGOT_EMAIL_URL,
        component: TempleForgotEmailComponent,
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
